import { SignUpForm, SignUpFormData } from '@src/features/user/auth';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import omit from 'lodash.omit';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '@stores/authStore.ts';
import { signUp } from '@src/services/auth.ts';
import { useCountryOptions } from '@hooks/useCountryOptions';
import { useStateOptions } from '@hooks/useStateOptions.ts';
import { USER_DUPLICATE_EMAIL_OR_NICKNAME } from '@src/constants';

export const SignUpPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { auth } = useAuthStore();
  const { countryOptions } = useCountryOptions();
  const { stateOptions } = useStateOptions();

  const handleSignup = async (data: SignUpFormData) => {
    try {
      const res = await signUp({
        ...omit(data, ['confirmPassword']),
        email: data.email.toLowerCase(),
      });

      auth.setAccessToken(res.data.token);
      navigate('/select-trading-platform', { replace: true });
    } catch (err: any) {
      const status = err?.response?.status;
      const errorCode = err?.response?.data?.error_code;
      const message = err?.response?.data?.message;

      // Backend may return 422 with a more specific error_code.
      const isDuplicateEmailOrNickname =
        errorCode === USER_DUPLICATE_EMAIL_OR_NICKNAME ||
        errorCode === 'USER__EMAIL_ALREADY_EXISTS' ||
        errorCode === 'USER__NICKNAME_ALREADY_EXISTS';

      if (status === 422 && isDuplicateEmailOrNickname) {
        toast.error(message || t('toast.duplicateEmailOrNickname'));

        return;
      }

      toast.error(message || t('toast.somethingWentWrong'));
    }
  };

  return (
    <SignUpForm
      countryOptions={countryOptions ?? []}
      states={stateOptions}
      onSubmit={handleSignup}
    />
  );
};
